import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SwitchComponent } from '@app/modules/core/components/switch/switch.component';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetConfigFormTemplate } from '../widget-config-form-template';

@Component({
  selector: 'topo-locations-widget-config-form',
  imports: [ReactiveFormsModule, TranslatePipe, SwitchComponent],
  templateUrl: './locations-widget-config-form.component.html',
  styleUrl: './locations-widget-config-form.component.scss'
})
export class LocationsWidgetConfigFormComponent extends WidgetConfigFormTemplate {}
